export default __webpack_public_path__ + "static/fit-5a2896fb9e78794c7f8d38175c3eed5a.png";